export function toIds(values = [], keys = []) {
  return (Array.isArray(values) ? values : []).map((item) => {
    if (typeof item === 'number') return item;
    return Number(keys.map((key) => item?.[key]).find(Boolean) || 0);
  }).filter(Boolean);
}

export function buildDoubtDraft(source = {}) {
  const raw = source?.raw || source || {};
  return {
    doubtId: Number(source?.id || raw?.doubt_id || source?.doubtId || 0),
    title: source?.title || raw?.title || '',
    description: source?.description || raw?.description || '',
    newAttachments: source?.newAttachments || [],
    existingAttachments: source?.existingAttachments || (Array.isArray(raw?.attachments) ? raw.attachments : []),
    deleteAttachmentIds: source?.deleteAttachmentIds || [],
    subjectIds: source?.subjectIds || toIds(raw?.subjects, ['subject_id', 'id']),
    topicIds: source?.topicIds || toIds(raw?.topics, ['topic_id', 'id']),
    tagCategoryIds: source?.tagCategoryIds || toIds(raw?.tags, ['tag_category_id', 'tag_id', 'id']),
  };
}

export function attachmentUrl(attachment) {
  return typeof attachment === 'string' ? attachment : attachment?.attachment_url || attachment?.image_url || attachment?.url || attachment?.file_url || '';
}
